import { ReactNode, useState } from 'react'
import { ActiveManagementHeaderSlotContext } from './ActiveManagementHeaderSlotContext'

// Provider component to wrap the application
export function ActiveManagementHeaderSlotProvider({
    children,
}: {
    children: ReactNode
}) {
    const [slot, setSlot] = useState<ReactNode>(null)

    return (
        <ActiveManagementHeaderSlotContext.Provider value={{ slot, setSlot }}>
            {children}
        </ActiveManagementHeaderSlotContext.Provider>
    )
}
